<template>
  <div>
    <div class="modal-on-load" data-target="#realmodelModal"></div>
    <!-- Modal -->
    <div class="modal1 mfp-hide subscribe-widget" id="realmodelModal">
      <div class="card noborder divcenter" style="max-width: 500px;">
        <img
          src="https://images.unsplash.com/photo-1537326756431-4c8d75079828?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2102&q=80"
          class="card-img-top"
          alt="Image"
        />
        <div class="card-body p-4">
          <h3 class="card-title font-body">포헤어 리얼모델 모집(부분모델)</h3>
          <ul class="iconlist">
            <li>
              <i class="icon-ok"></i> <strong>모집대상:</strong> 20-50대 남성 및
              여성
            </li>
            <li>
              <i class="icon-ok"></i> <strong>1,000 모낭 기준:</strong> 300만원
              할인
            </li>
            <li>
              <i class="icon-ok"></i> <strong>신청방법:</strong> 개별연락 또는
              상담하기(상담내용에 <b>리얼모델</b> 신청 게재)
            </li>
          </ul>

          <div class="form-widget">
            <form
              class="nobottommargin position-relative"
              id="modal-health"
              name="modal-health"
              action="include/form.php"
              method="post"
              enctype="multipart/form-data"
            >
              <div class="form-process"></div>
              <div class="row">
                <div class="col-12 form-group">
                  <small
                    >* 모량에 따라 차액 발생할 수 있음. 내원 상담 후 정확한
                    수술량, 디자인, 비용 확정</small
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Counsel",
  methods: {}
};
</script>

<style scoped></style>
